<script setup lang="ts">
const { color = "#333333" } = defineProps<{
  color?: string;
}>();
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 64 64">
    <polygon points="32,2 62,62 2,62" :fill="color" />
  </svg>
</template>
